import { AbstractModel } from '@/models/abstractModel';
import { EventFeedType, EventPeriod, Jollywhere } from '@/constants';
import { IGameGridItemData } from '@/types';

export class GameGridItem extends AbstractModel {
    public periodTypeId: EventPeriod;
    public customEventId: string;
    public leagueName: string;
    public iso3: string | null;
    public teamHomeName: string;
    public teamAwayName: string;
    public teamHomeLogo: string | null;
    public teamAwayLogo: string | null;
    public jollywhere: Jollywhere | null;
    public time: string | null;
    public scoreHome: number | null;
    public scoreAway: number | null;
    public cornersHome: number | null;
    public cornersAway: number | null;
    public eventFeedType: EventFeedType | null;

    constructor(data: IGameGridItemData) {
        super();

        this.periodTypeId = data.periodTypeId;
        this.customEventId = data.customEventId;
        this.leagueName = data.leagueName;
        this.iso3 = data.iso3 || null;
        this.teamHomeName = data.teamHomeName;
        this.teamAwayName = data.teamAwayName;
        this.teamHomeLogo = data.teamHomeLogo;
        this.teamAwayLogo = data.teamAwayLogo;
        this.jollywhere = data.jollywhere;
        this.time = data.time;
        this.scoreHome = data.scoreHome;
        this.scoreAway = data.scoreAway;

        this.cornersHome = data.cornersHome;
        this.cornersAway = data.cornersAway;
        this.eventFeedType = data.eventFeedType || null;
    }

    public get scoreFull(): string {
        if (this.scoreHome === null) {
            return '';
        }
        return `${this.scoreHome}-${this.scoreAway}`;
    }

    public get displayedScore(): string {
        if (this.scoreHome === null) {
            return '';
        }
        return `${this.scoreHome} - ${this.scoreAway}`;
    }

    public get cornersSum(): number {
        if (this.cornersHome === null) {
            return 0;
        }
        return Number(this.cornersHome) + Number(this.cornersAway);
    }

    public get displayedCorners(): string {
        if (this.cornersHome === null) {
            return '';
        }
        return `${this.cornersHome} - ${this.cornersAway}`;
    }
}
